import React from 'react'
import { Paper ,InputBase ,IconButton } from '@mui/material';
import { BsSearch } from "react-icons/bs";

const SearchBar = ({ onSearch }) => {
  const handleSearch = (e) => {
    onSearch(e.target.value);
  };

  return (
    <div 
      style={{
        position: "absolute",
        top: "70px",
      }}>
      <Paper 
        component="form" 
        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}>
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder="Recherche ..."
          inputProps={{ 'aria-label': 'search google maps' }}
          onChange={handleSearch}
        />
        <IconButton sx={{ p: '10px' }} aria-label="search">
          <BsSearch />
        </IconButton>
      </Paper>
    </div>
  );
}

export default SearchBar